import { render, staticRenderFns } from "./GuideNotes.vue?vue&type=template&id=3917ba22&scoped=true"
import script from "./GuideNotes.vue?vue&type=script&lang=js"
export * from "./GuideNotes.vue?vue&type=script&lang=js"
import style0 from "./GuideNotes.vue?vue&type=style&index=0&id=3917ba22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3917ba22",
  null
  
)

export default component.exports